export default "__VITE_ASSET__Do7VZM8Z__"